import { render, staticRenderFns } from "./TechTreeTabSelector.vue?vue&type=template&id=d1c2ded0&scoped=true&"
import script from "./TechTreeTabSelector.vue?vue&type=script&lang=js&"
export * from "./TechTreeTabSelector.vue?vue&type=script&lang=js&"
import style0 from "./TechTreeTabSelector.vue?vue&type=style&index=0&id=d1c2ded0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c2ded0",
  null
  
)

export default component.exports